import { useParams, Navigate } from "react-router-dom";
import { PRACTICES, findPractice } from "@/data/solutions";
import { PRACTICE_ICONS } from "@/components/LineIcons";
import EntityDetailPage from "@/components/EntityDetailPage";
import SEO from "@/components/SEO";
import { TESTIDS } from "@/constants/testIds";

export default function PracticeDetail() {
    const { id } = useParams();
    const p = findPractice(id);
    if (!p) return <Navigate to="/practices" replace />;

    const siblings = PRACTICES.map((x) => ({
        id: x.id,
        name: x.name,
        path: `/practices/${x.id}`,
        icon: PRACTICE_ICONS[x.id],
        current: x.id === id,
    }));

    return (
        <>
            <SEO
                path={`/practices/${p.id}`}
                title={`${p.name} practice, ${p.short || "KyroLabs"}`}
                description={p.long}
            />
            <EntityDetailPage
                testId={TESTIDS.practices.card(p.id)}
                kicker="Practice"
                title={p.name}
                tagline={p.short}
                body={p.long}
                subItems={p.offerings}
                subLabel="What we deliver"
                accent={p.color}
                image={p.image}
                bookSource={`practices-detail:${p.id}`}
                siblings={siblings}
                siblingsLabel="Explore practices"
            />
        </>
    );
}
